var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, StackView } from "../StackView";
import { Text, TEXT_WEIGHT } from "../Text";
import { SPACE_FILL } from "../View";
var TimeHeaderCell = function (_a) {
    var value = _a.value, strong = _a.strong, leftValue = _a.leftValue;
    return (React.createElement(StackView, { root: true, spaceFill: SPACE_FILL.all, align: STACK_ALIGN.center, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.end },
        leftValue && (React.createElement(Text, { weight: TEXT_WEIGHT.bold, style: { position: 'absolute', left: -4 } }, leftValue)),
        React.createElement(StackView, { style: { right: -8, position: 'relative', width: 16 }, align: STACK_ALIGN.center, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.center },
            React.createElement(Text, { weight: strong ? TEXT_WEIGHT.bold : TEXT_WEIGHT.normal }, value))));
};
export var SCHEDULING_MATRIX_COLUMN_TIME_PRESET = __spreadArrays([
    {
        renderCel: function () { return React.createElement(TimeHeaderCell, { value: 1, leftValue: 12 }); }
    }
], [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (value) { return ({
    renderCel: function () { return React.createElement(TimeHeaderCell, { value: value, strong: value % 2 == 0 }); }
}); })).map(function (i, idx) { return (__assign(__assign({}, i), { key: "" + idx })); });
//# sourceMappingURL=timeHeader.js.map